require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-behind-the-algorithm-students-create-apps-to-demonstrate-computer-science-concepts.json") })
        }
      }, "path---blog-behind-the-algorithm-students-create-apps-to-demonstrate-computer-science-concepts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-behind-the-algorithm-students-create-apps-to-demonstrate-computer-science-concepts!./.cache/json/blog-behind-the-algorithm-students-create-apps-to-demonstrate-computer-science-concepts.json
// module id = 727
// module chunks = 231608221292675